import { useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";
import { api } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const CategoryManager = ({ categories, onChange }) => {
  const [name, setName] = useState("");
  const [adding, setAdding] = useState(false);

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setAdding(true);
    try {
      await api.post("/categories", { name: name.trim() });
      toast.success("Kategori eklendi");
      setName("");
      onChange();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Eklenemedi");
    } finally {
      setAdding(false);
    }
  };

  const del = async (c) => {
    if (!window.confirm(`"${c.name}" kategorisi silinsin mi?`)) return;
    try {
      await api.delete(`/categories/${c.id}`);
      toast.success("Kategori silindi");
      onChange();
    } catch {
      toast.error("Silme başarısız");
    }
  };

  return (
    <div className="bg-white border border-stone-200 p-8" data-testid="category-manager">
      <form onSubmit={add} className="flex gap-3 max-w-md mb-8">
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Yeni kategori adı" data-testid="category-name-input" />
        <Button type="submit" disabled={adding} className="bg-stone-900 hover:bg-wood text-stone-50 rounded-none shrink-0" data-testid="category-add-button">
          <Plus size={15} className="mr-1" /> Ekle
        </Button>
      </form>
      <ul className="divide-y divide-stone-100">
        {categories.map((c) => (
          <li key={c.id} className="flex items-center justify-between py-4" data-testid={`category-row-${c.slug}`}>
            <span className="text-stone-800 font-medium">{c.name} <span className="text-stone-400 text-sm font-light">({c.slug})</span></span>
            <button onClick={() => del(c)} className="p-2 text-stone-400 hover:text-red-700" data-testid={`category-delete-${c.slug}`} aria-label="Sil">
              <Trash2 size={15} />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
